import React, { Component } from 'react';
import { NavLink, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import TeamVoucherComponent from './TeamVoucherComponent';
import VoucherBalance from './VoucherBalance';

import * as actions from 'actions/index';
import './voucher.scss';

class TeamVoucher extends Component {
  componentDidMount() {
    this.props.onChangeTitleHeader('Vouchers');
  }

  render() {
    return (
      <div className="main-content">
        <div className="list-items team-voucher">
          <div>
            <ul className="header-list-team-voucher">
              <li>
                <NavLink activeClassName="active" to="/Menu/teamvoucher" exact>
                  Team Voucher
                </NavLink>
              </li>
              <li>
                <NavLink
                  activeClassName="active"
                  to="/Menu/teamvoucher/companyvoucher"
                >
                  Voucher Balance
                </NavLink>
              </li>
            </ul>
            <Switch>
              <Route
                path="/Menu/teamvoucher"
                exact
                render={() => <TeamVoucherComponent />}
              />
              <Route
                path="/Menu/teamvoucher/companyvoucher"
                render={() => <VoucherBalance />}
                exact
              />
            </Switch>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onChangeTitleHeader: titleHeader =>
      dispatch(actions.changeMenuTitleHeader(titleHeader)),
  };
};

export default connect(null, mapDispatchToProps)(TeamVoucher);



// WEBPACK FOOTER //
// ./src/containers/TeamVoucher/index.js